import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { AuditModule } from '../audit/audit.module';
import { AuthModule } from '../auth/auth.module';
import { CartModule } from '../cart/cart.module';
import { ShippingModule } from '../shipping/shipping.module';
import { CheckoutController } from './checkout.controller';
import { CheckoutService } from './checkout.service';

@Module({
  // ShippingModule so checkout prices through the same service the storefront
  // quoted from. Two pricing paths would eventually disagree, and the shopper
  // would be charged the one they were never shown.
  imports: [AuditModule, AuthModule, CartModule, ShippingModule],
  controllers: [CheckoutController],
  providers: [CheckoutService, PrismaService],
  exports: [CheckoutService],
})
export class CheckoutModule {}
